import { generate } from "shortid";
import { PAGE_THEMES } from "../../types";
import { getCategoryById } from "@/utils";
import {
  PHOBIA_LIST_ALPABETICAL,
  GIRL_CHILD_IMAGES,
  BOY_CHILD_IMAGES,
  AVAILABLE_GENDERS,
  GENDER_NEUTRAL_IMAGES,
} from "@/config";

export const PARENT_WELCOME_PAGES = {
  parent_choose_child_phobia_page: {
    id: `parent_choose_child_phobia_page-${generate()}`,
    type: "multi_select_type",
    title: null,
    backwards_navigation_enabled: true,
    target_state: "welcome_data",
    target_field: "choose_phobias",
    target_pages: [
      {
        name: "parent_program_category_page",
        data_key: "options",
        action: (data) =>
          data.map((phobia, i) => {
            const data = getCategoryById(phobia);

            return {
              id: `category-item-${i}-${generate()}`,
              label: "Category",
              value: data.id,
              target_field: null,
              to: null,
              icon: data.image,
              text: data.title,
              description: data.tagline,
              isActive: false,
            };
          }),
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What worries your child?",
      description:
        "What specific fears or worries do you want to work on? Choose several, or add more later.",
      image: null,
      custom_back: null,
      default_progression: "parent_child_age_select_page",
      options: [
        {
          id: `option-item-social-anx-${generate()}`,
          label: "Social Anxiety",
          description: null,
          icon: "social-anxiety",
          target_field: "choose_phobias",
          to: "phobia_info_page",
          value: 4,
          content: "Fear of Social Situations",
          isActive: false,
        },
        ...PHOBIA_LIST_ALPABETICAL.filter((phobia) => phobia.id !== 16).map(
          (phobia, i) => ({
            id: `option-item-${i}-${generate()}`,
            label: phobia.description,
            description: phobia.title,
            icon: phobia.image,
            target_field: "choose_phobias",
            to: "phobia_info_page",
            value: phobia.id,
            content: phobia.text,
            isActive: false,
          })
        ),
      ],
    },
  },
  parent_child_age_select_page: {
    id: `parent_child_age_select_page-${generate()}`,
    type: "single_select_type",
    title: null,
    backwards_navigation_enabled: true,
    target_state: "welcome_data",
    target_field: "age_select",
    target_pages: [
      {
        name: "parent_program_category_page",
        data_key: "options",
        action: (ageValue, options) => {
          const data = getCategoryById(ageValue);

          return [
            ...options,
            {
              id: `child-program-${generate()}`,
              label: "Category",
              value: data.id,
              target_field: null,
              to: null,
              icon: data.image,
              text: data.title,
              description: data.tagline,
              isActive: false,
            },
          ];
        },
      },
    ],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How old is your child?",
      description: "We’ll tailor your program to your child's age group",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "5 - 9 years",
          to: "parent_child_name_input_page",
          value: 21,
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "10 - 13 years",
          to: "parent_child_name_input_page",
          value: 22,
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "14 - 17 years",
          to: "parent_child_name_input_page",
          value: 24,
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  parent_child_name_input_page: {
    id: `parent_child_name_input_page-${generate()}`,
    type: "input_type",
    backwards_navigation_enabled: true,
    title: null,
    target_state: "welcome_data",
    target_field: "name_input",
    target_pages: [
      {
        name: "parent_child_gender_select_page",
        data_key: "title",
        action: (data) => {
          return `What is ${data}'s gender?`;
        },
      },
      {
        name: "parent_child_avatar_select_page",
        data_key: "title",
        action: (data) => {
          return `${data}'s Avatar`;
        },
      },
      {
        name: "parent_program_celebrate_page",
        data_key: "title",
        action: (data) => {
          return `You're in good hands, ${data}`;
        },
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your childs name?",
      description: null,
      image: null,
      custom_back: null,
      default_progression: "parent_child_gender_select_page",
      options: [],
    },
  },
  parent_child_gender_select_page: {
    id: `parent_child_gender_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: null,
    target_state: "welcome_data",
    target_field: "choose_gender",
    target_pages: [
      {
        name: "parent_child_avatar_select_page",
        data_key: "options",
        action: (data) => {
          const mapDataToItem = (list) =>
            list.map((item, i) => ({
              id: `option-item-${i}-${generate()}`,
              label: null,
              to: "parent_program_category_page",
              value: item.id,
              target_field: "choose_avatar",
              icon: item.image,
              text: null,
              description: null,
              isActive: false,
            }));

          switch (data) {
            case AVAILABLE_GENDERS.man:
              return mapDataToItem(BOY_CHILD_IMAGES);
            case AVAILABLE_GENDERS.woman:
              return mapDataToItem(GIRL_CHILD_IMAGES);
            case AVAILABLE_GENDERS.unknown:
              return mapDataToItem(GENDER_NEUTRAL_IMAGES);
            case AVAILABLE_GENDERS.diverse:
              return mapDataToItem(GENDER_NEUTRAL_IMAGES);
            default:
              return mapDataToItem(GENDER_NEUTRAL_IMAGES);
          }
        },
      },
    ],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your childs gender?",
      description:
        "This helps us personalize your plan. Gender affects anxiety. We also experience anxiety differently across genders.",
      image: null,
      custom_back: null,
      default_progression: "parent_child_avatar_select_page",
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "Male",
          to: "parent_child_avatar_select_page",
          value: "male",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Female",
          to: "parent_child_avatar_select_page",
          value: "female",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Gender diverse",
          to: "parent_program_category_page",
          value: "diverse",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "Prefer not to say",
          to: "parent_program_category_page",
          value: "unknown",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  parent_child_avatar_select_page: {
    id: `parent_child_avatar_select_page-${generate()}`,
    type: "avatar_select_type",
    backwards_navigation_enabled: true,
    title: null,
    target_state: "welcome_data",
    target_field: "choose_avatar",
    target_pages: [
      {
        name: "parent_program_category_page",
        data_key: "options",
        action: (avatar, options) => {
          const findProgramIndex = options.findIndex(
            (opt) => opt.value === 24 || opt.value === 22 || opt.value === 21
          );

          if (findProgramIndex > -1) {
            const newOptions = [...options];
            const list = [...BOY_CHILD_IMAGES, ...GIRL_CHILD_IMAGES];

            const newProgram = {
              ...newOptions[findProgramIndex],
              icon: list.find((item) => item.id === avatar)?.image,
            };

            newOptions[findProgramIndex] = newProgram;

            return newOptions;
          }

          return [];
        },
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Avatar",
      description: "Choose an avatar that suits best",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [],
    },
  },
};
